import { InputHTMLAttributes } from 'react';
import Form from 'react-bootstrap/Form';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'value'> {
  label?: string;
  value?: string | number;
}

export function Input({ label, className, ...props }: InputProps) {
  return (
    <Form.Group className="mb-3">
      {label && <Form.Label className="lizzi-form-label">{label}</Form.Label>}
      <Form.Control className={['lizzi-form-control', className].filter(Boolean).join(' ')} {...props} />
    </Form.Group>
  );
}
